import i18n_base_ui from '@/locales/keys/i18n_base_ui.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { EShortcutGroup } from '@shared/dto/hint_shortcuts/e_shortcut_group';
import { useTranslation } from 'react-i18next';

interface Props {
  group: EShortcutGroup;
}

export function ViewAllHintsShortcutsGroupHeader({ group }: Props) {
  const { t } = useTranslation(ENUM__i18n_namespace.BASE_UI);

  return (
    <div className="w-full flex flex-col justify-center items-center">
      <div className="w-full text-left text-page-foreground text-lg font-semibold py-2 h-[40px]">{t(i18n_base_ui.shortcut_hints_groups[group])}</div>
    </div>
  );
}
